// import $ from 'jquery';
import '../Components/_Animation.js';
import '../Components/_Anchor.js';
import '../Components/_Header.js';
import '../Components/_Slider.js';
import '../Components/_Modal.js';
import '../Components/_Accordion.js';
